/* eslint-disable no-sequences */
/* eslint-disable react/prop-types */
// React
import React, { useState, useEffect } from 'react';
// PropType
import PropTypes from 'prop-types';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
// MUI
import {
  Paper,
  Avatar,
  Box,
  Typography,
  Link,
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
  Checkbox,
  Grid,
  Divider,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
// Images
import UserIcon from 'aurora-images/user_profileV3.svg';
import CompanyIcon from 'aurora-images/Company_avatar.svg';
// Utils

import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
// styles
import withStyles from '@material-ui/core/styles/withStyles';
import { ADGMItemDetails } from 'aurora-components';
import styles from './styles';
import { keyEmptyCheck } from '../../utils/utils';

/** ****************
Props Documentation:
--------------------
entites : array of owners comes from current application (application.owners)
contractDetails: object of contract details comes from Reducer 
setContractDetails: function to set contract details comes from mortgage Action (modules/mortgage/actions.js)
isEditable: to show the radio buttons
***************** */

const EntityDetails = ({
  classes,
  entites,
  contractDetails,
  setContractDetails,
  isEditable,
  title,
  children,
  disableAllShares,
  application,
}) => {
  const dispatch = useDispatch();
  const { lang } = useSelector(
    createSelector(
      state => state.language,
      language => ({
        lang: language.locale,
      }),
    ),
  );

  useEffect(() => {
    if (isArray(entites) && entites?.length === 1 && isEditable) {
      dispatch(
        setContractDetails({
          key: 'propertyDetails',
          value: {
            ...contractDetails?.propertyDetails,
            isSharedMortgage: false,
          },
        }),
      );
    }
  }, [entites, isEditable]);

  const [selectedValue, setSelectedValue] = useState(contractDetails?.propertyDetails?.customerIds || []);

  const [entitesCollapse, setEntitesCollapse] = useState(true);

  const handleChange = key => {
    // setSelectedValue(event.target.value);
    dispatch(
      setContractDetails({
        key: key.target.name,
        value: {
          ...contractDetails?.propertyDetails,
          isSharedMortgage: key.target.value !== 'all_shares',
        },
      }),
    );
  };
  const handleChangechecked = event => {
    const mySet1 = selectedValue;

    if (mySet1.indexOf(parseFloat(event.target.value)) === -1) {
      mySet1.push(parseFloat(event.target.value));
    } else {
      mySet1.splice(mySet1.indexOf(parseFloat(event.target.value)), 1);
    }
    setSelectedValue(mySet1);

    dispatch(
      setContractDetails({
        key: event.target.name,
        value: {
          ...contractDetails?.propertyDetails,
          customerIds: selectedValue,
        },
      }),
    );
  };

  const ENTITIES = entites?.map(entity => {
    return {
      ...entity,
      entityNameEn:
        entity?.ownerNameEn ??
        entity?.buyerNameEn ??
        entity?.nameEn ??
        entity?.tenName ??
        entity?.nameEn ??
        entity?.companyName ??
        entity?.occName ??
        entity?.name ??
        entity?.musatehNameEn,
      entityNameAr:
        entity?.ownerNameAr ??
        entity?.buyerNameAr ??
        entity?.nameAr ??
        entity?.tenNameAr ??
        entity?.nameAr ??
        entity?.companyNameAr ??
        entity?.occNameAr ??
        entity?.musatehNameAr,
      EID:
        entity?.emiratesId ??
        entity?.eidOrUnified ??
        entity?.eidNumberOrUnified ??
        entity?.occId ??
        entity?.lessorId ??
        entity?.eidNumber ??
        entity?.eid,
      tradeLicense: entity?.tradeLicenseNumber ?? entity?.tradeLicenseNo ?? entity?.licenseNumber,
      phoneNumber:
        entity?.phoneNumber ??
        entity?.phone ??
        entity?.tenPhone ??
        entity?.compPhone ??
        entity?.mobileNumber ??
        entity?.mobile,
      nationalityEn: entity?.nationalityEn ?? entity?.nationality,
      nationalityAr: entity?.nationalityAr,
      email: entity?.email ?? entity?.compEmail ?? entity?.tenEmail ?? entity?.email,
      rightHoldTypeEn: entity?.rightHoldTypeEn,
      rightHoldTypeAr: entity?.rightHoldTypeAr,
      ownerShare: entity?.ownerShare,
    };
  });

  const renderChildren = (index, entity) => {
    let childrenReadyToDisplay = children;

    // if you want to display specific child on each entity

    if (children[0]?.props?.parentId) {
      // eslint-disable-next-line react/prop-types
      childrenReadyToDisplay = children.filter(({ props }) => props?.parentId === entity.customerId);
    }

    if (entitesCollapse && index === 0) {
      return childrenReadyToDisplay;
    }

    if (!entitesCollapse) {
      return (
        <>
          {childrenReadyToDisplay}
          {index < entites.length - 1 && <Divider className={classes.divider} />}
        </>
      );
    }
    return null;
  };

  return (
    <>
      {isEditable && entites?.length > 1 && (
        <Paper className={(classes.paperCardFrame, classes.marginBottom)}>
          <div className={classes.titleHead}>
            <Typography variant='h6' component='h1' className={classes.title}>
              {keyEmptyCheck('select_mortgage_shares')}
              <span className={classes.textDanger}>*</span>
            </Typography>
          </div>

          <div className={classes.container}>
            <FormControl component='fieldset' className={classes.fieldsetradio}>
              <RadioGroup row aria-labelledby='demo-row-radio-buttons-group-label' name='row-radio-buttons-group'>
                <FormControlLabel
                  value='all_shares'
                  onClick={handleChange}
                  checked={contractDetails?.propertyDetails?.isSharedMortgage === false}
                  name='propertyDetails'
                  disabled={disableAllShares}
                  control={<Radio className={classes.radio} />}
                  label={keyEmptyCheck('mortgage_plot_including_all_shares')}
                />
                <FormControlLabel
                  value='selected_shares'
                  checked={contractDetails?.propertyDetails?.isSharedMortgage === true}
                  onChange={handleChange}
                  name='propertyDetails'
                  control={<Radio className={classes.radio} />}
                  label={keyEmptyCheck('mortgage_specific_shares')}
                />
              </RadioGroup>
            </FormControl>
          </div>
        </Paper>
      )}

      {!isEmpty(entites) && entites?.length > 0 && (
        <Paper className={(classes.paperCardFrame, classes.marginBottom)}>
          <div className={classes.titleHead}>
            <div className={classes.title}>
              <span>
                {keyEmptyCheck(title)}
                {/* {!isEmpty(entites) && entites.length > 1 ? `(${entites.length})` : ''} */}
              </span>
            </div>
          </div>
          {ENTITIES.map((entity, index) => {
            const labelId = `propertyDetails`;
            const isCompany = !!entity?.tradeLicense;

            let isPOA = null;
            if (application?.poaInitiatorDTO) {
              isPOA = entity?.customerId === application.poaInitiatorDTO.ownerCustomerId;
            }

            return (
              <>
                <div
                  key={entity.customerId}
                  className={classes.container}
                  style={{
                    display: entitesCollapse && index >= 3 ? 'none' : 'inherit',
                    borderBottom: '1px solid #EBEEF3',
                  }}
                >
                  <div>
                    <Grid container spacing={1}>
                      {contractDetails?.propertyDetails?.isSharedMortgage && isEditable && (
                        <Grid item xs={1}>
                          <Checkbox
                            checked={selectedValue?.some(build => build === entity.customerId) || false}
                            onClick={handleChangechecked}
                            value={entity.customerId}
                            name={labelId}
                          />
                        </Grid>
                      )}
                      <Grid item xs={contractDetails?.propertyDetails?.isSharedMortgage ? 11 : 12}>
                        <Grid container spacing={2}>
                          <Grid item md={3}>
                            <Box item sx={{ gridRow: '1 / 3' }} className={classes.flex}>
                              <Avatar
                                alt='avatar'
                                src={isCompany ? CompanyIcon : UserIcon}
                                className={classes.ownerAvatarimg}
                              />
                              <Box>
                                <ADGMItemDetails
                                  label={
                                    <span>
                                      {keyEmptyCheck('owner')} # {index + 1}
                                    </span>
                                  }
                                  value={(lang === 'en' ? entity?.entityNameEn ?? '-' : entity?.entityNameAr) ?? '-'}
                                />
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item md={9}>
                            <Grid container spacing={2}>
                              {/* <Grid item xs={6} sm={3}>
                                <ADGMItemDetails
                                  label={
                                    <span>
                                      {keyEmptyCheck('owner')} # {index + 1}
                                    </span>
                                  }
                                  value={(lang === 'en' ? entity?.entityNameEn ?? '-' : entity?.entityNameAr) ?? '-'}
                                />
                              </Grid> */}
                              {isCompany ? (
                                <Grid item xs={6} sm={4}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('trade_license_number')}
                                    value={
                                      entity?.tradeLicenseNumber ??
                                      entity?.licenseNumber ??
                                      entity?.tradeLicenseNo ??
                                      '-'
                                    }
                                  />
                                </Grid>
                              ) : (
                                <Grid item xs={6} sm={4}>
                                  <ADGMItemDetails label={keyEmptyCheck('emirates_ID')} value={entity?.EID ?? '-'} />
                                </Grid>
                              )}
                              {entity?.moiUnifiedNumber && (
                                <Grid item xs={6} sm={4}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('moi_unified_number')}
                                    value={entity?.moiUnifiedNumber ?? '-'}
                                  />
                                </Grid>
                              )}
                              {(!!entity?.nationalityEn || entity?.nationalityAr) && (
                                <Grid item xs={6} sm={4}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('nationality')}
                                    value={(lang === 'en' ? entity?.nationalityEn : entity?.nationalityAr) ?? '-'}
                                  />
                                </Grid>
                              )}

                              {entity?.repName && (
                                <Grid item xs={6} sm={4}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('representor_name')}
                                    value={entity?.repName ?? '-'}
                                  />
                                </Grid>
                              )}
                              {entity?.repId && (
                                <Grid item xs={6} sm={4}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('representor_Id')}
                                    value={entity?.repId ?? '-'}
                                  />
                                </Grid>
                              )}
                              <Box item />

                              {/* {!!entity?.ownerShare && (
                              <Grid item xs={6} sm={3}>
                                <ADGMItemDetails
                                  label={keyEmptyCheck('property_share')}
                                  value={entity?.ownerShare + '%' ?? '-'}
                                />
                              </Grid>
                            )} */}
                              {!!entity?.ownerShare && (
                                <Grid item xs={6} sm={4}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('property_share')}
                                    value={entity?.ownerShare + '%' ?? '-'}
                                  />
                                </Grid>
                              )}
                              {(!!entity?.plotTransactionTypeNameE || !!entity?.plotTransactionTypeNameA) && (
                                <Grid item xs={6} sm={4}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('acquisition_type')}
                                    value={
                                      lang === 'en'
                                        ? entity?.plotTransactionTypeNameE
                                        : entity?.plotTransactionTypeNameA
                                    }
                                  />
                                </Grid>
                              )}
                              {!!entity?.contractPercentage && (
                                <Grid item xs={6} sm={4}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('buying_percentage')}
                                    value={entity?.contractPercentage ? `${entity?.contractPercentage}%` : '-'}
                                    valueClass={classes.redColor}
                                  />
                                </Grid>
                              )}
                              <Grid item xs={6} sm={4}>
                                <ADGMItemDetails
                                  label={keyEmptyCheck('Phone_Number')}
                                  value={entity?.phoneNumber ?? '-'}
                                />
                              </Grid>
                              <Grid item xs={6} sm={4}>
                                <ADGMItemDetails label={keyEmptyCheck('Email')} value={entity?.email ?? '-'} />
                              </Grid>
                              {/* 
                            <Grid item xs={6} sm={3}>
                              <ADGMItemDetails label={keyEmptyCheck('owner_share')} value={entity?.ownerShare ?? '-'} />
                            </Grid> */}
                              <Grid item xs={6} sm={4}>
                                <ADGMItemDetails
                                  label={keyEmptyCheck('right_hold_type')}
                                  value={
                                    entity?.rightHoldTypeEn === 'Ownership'
                                      ? keyEmptyCheck('free_hold')
                                      : keyEmptyCheck('lease_hold')
                                  }
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>

                  {/* TODO */}

                  {isPOA && (
                    <div>
                      <Typography className={classes.pOA}>{keyEmptyCheck('poa_details')}</Typography>
                      <Grid
                        item
                        xs={contractDetails?.propertyDetails?.isSharedMortgage ? 11 : 12}
                        className={isPOA ? classes.test : ''}
                      >
                        <Grid container spacing={2}>
                          <Grid item md={1}>
                            <Box item sx={{ gridRow: '1 / 3' }} className={classes.flex}>
                              <Avatar alt='avatar' src={UserIcon} className={classes.ownerAvatarimg} />
                            </Box>
                          </Grid>
                          <Grid item md={11}>
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={3}>
                                <ADGMItemDetails
                                  label={<span>{keyEmptyCheck('owner')}</span>}
                                  value={
                                    (lang === 'en'
                                      ? application?.poaInitiatorDTO?.nameEn ?? '-'
                                      : application?.poaInitiatorDTO?.nameAr) ?? '-'
                                  }
                                />
                              </Grid>
                              <Grid item xs={6} sm={3}>
                                <ADGMItemDetails
                                  label={keyEmptyCheck('emirates_id')}
                                  value={application?.poaInitiatorDTO?.eid || '-'}
                                />
                              </Grid>

                              {application?.poaInitiatorDTO?.agreementNumber && (
                                <Grid item xs={6} sm={3}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('poa_number')}
                                    value={application?.poaInitiatorDTO?.agreementNumber ?? '-'}
                                  />
                                </Grid>
                              )}
                              {application?.poaInitiatorDTO?.agreementStartDate && (
                                <Grid item xs={6} sm={3}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('poa_issuance_date')}
                                    value={application?.poaInitiatorDTO?.agreementStartDate ?? '-'}
                                  />
                                </Grid>
                              )}
                              {application?.poaInitiatorDTO?.agreementExpireDate && (
                                <Grid item xs={6} sm={3}>
                                  <ADGMItemDetails
                                    label={keyEmptyCheck('poa_expiry_date')}
                                    value={application?.poaInitiatorDTO?.agreementExpireDate ?? '-'}
                                  />
                                </Grid>
                              )}

                              <Box item />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                </div>

                {children && renderChildren(index, entity)}
              </>
            );
          })}
          {!isEmpty(entites) && entitesCollapse && entites.length > 3 ? (
            <div className={classes.viewmoreHolder}>
              <Link onClick={() => setEntitesCollapse(!entitesCollapse)}>
                {keyEmptyCheck('view_more')}
                {entites?.length > 0 && ` ( ${entites?.length - 3} )`}
                <ExpandMoreIcon />
              </Link>
            </div>
          ) : (
            ''
          )}
          {!isEmpty(entites) && !entitesCollapse && (
            <div className={classes.viewmoreHolder}>
              <Link onClick={() => setEntitesCollapse(!entitesCollapse)}>
                {keyEmptyCheck('view_less_reasons')} <ExpandLessIcon />
              </Link>
            </div>
          )}
        </Paper>
      )}
    </>
  );
};

EntityDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  entites: PropTypes.array.isRequired,
  contractDetails: PropTypes.object,
  setContractDetails: PropTypes.func,
  isEditable: PropTypes.bool,
  disableAllShares: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.element,
};

EntityDetails.defaultProps = {
  isEditable: false,
  disableAllShares: false,
  children: undefined,
  contractDetails: {},
  setContractDetails: () => {},
};
export default withStyles(styles)(EntityDetails);
